type AnalyticsData = Record<string, string | number | boolean>;

declare global {
  interface Window {
    umami?: {
      track(name: string, data?: AnalyticsData): void | Promise<unknown>;
    };
  }
}

export function trackEvent(name: string, data?: AnalyticsData): void {
  if (typeof window === "undefined") return;
  try {
    const result = window.umami?.track(name, data);
    if (result) void Promise.resolve(result).catch(() => {});
  } catch {
    // Analytics must never interrupt business operations.
  }
}

// Only fixed event names and dimensions leave the app. Never forward URLs,
// record IDs, query parameters, request bodies, or response content.
export function trackApiSuccess(
  endpoint: string,
  method: string,
  status: number,
  source: "online" | "offline_sync",
): void {
  if (method.toUpperCase() !== "POST" || status < 200 || status >= 300) return;
  const path = endpoint.split("?")[0];
  let event: string | undefined;
  if (path === "/purchase-orders" && status === 201) {
    // Replayed creation returns 200; do not count it as another order.
    event = "purchase_order_created";
  } else if (/^\/purchase-orders\/[^/]+\/submit$/.test(path)) {
    event = "purchase_order_submitted";
  } else if (/^\/purchase-orders\/[^/]+\/cancel$/.test(path)) {
    event = "purchase_order_cancelled";
  } else if (/^\/supplier-receipts\/[^/]+\/confirm$/.test(path)) {
    event = "supplier_receipt_confirmed";
  } else if (/^\/stocktakes\/[^/]+\/submit$/.test(path)) {
    event = "stocktake_submitted";
  } else if (/^\/stocktakes\/[^/]+\/approve$/.test(path)) {
    event = "stocktake_approved";
  }
  if (event) trackEvent(event, { source });
}